module.exports = __webpack_public_path__ + "assets/usersQuestion.f22c4b6b.svg";